var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rsvp-container",class:_vm.rootClassName},[_c('a',{staticClass:"rsvp-rsvp button",attrs:{"href":"mailto:info@marieke-and-sven.com?subject=RSVP"}},[_vm._v(" "+_vm._s(_vm.RSVP)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }